class Toolbarmobile extends HTMLElement {
  constructor() {
    super();

    if (theme.config.mqlSmall || theme.config.isTouch) {
      this.init();
    }
  }

  init() {
    this.activate();

    this.resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (!entry) return;

      document.body.style.setProperty(
        '--toolbar-mobile-height',
        `${entry.contentRect.height}px`
      );
    });

    this.resizeObserver.observe(this);
  }

  activate() {
    const header = document.querySelector(
      ".header[data-sticky-state='inactive']"
    );

    header === null
      ? this.classList.add('active')
      : this.classList.remove('active');
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define('toolbar-mobile', Toolbarmobile);